export default function loadClient(options) {
    function go() {
        if (window.jgChromeClientLoad) {
            window.jgChromeClientLoad(options);
        }
    }
    if (window.jgChromeClientLoad) {
        go();
    }
    else {
        window.jgChromeClientAsyncInit = go;
    }
}
//# sourceMappingURL=loadClient.js.map